/**
 * @generated SignedSource<<6c58e708fd703b892db6c31def916cd5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkspaceMembersPageRemoveMutation$variables = {
  memberId: string;
};
export type WorkspaceMembersPageRemoveMutation$data = {
  readonly removeWorkspaceMember: boolean;
};
export type WorkspaceMembersPageRemoveMutation = {
  response: WorkspaceMembersPageRemoveMutation$data;
  variables: WorkspaceMembersPageRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "memberId",
        "variableName": "memberId"
      }
    ],
    "kind": "ScalarField",
    "name": "removeWorkspaceMember",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceMembersPageRemoveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceMembersPageRemoveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "da8831573fd440feaf4809cc9ac39469",
    "id": null,
    "metadata": {},
    "name": "WorkspaceMembersPageRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceMembersPageRemoveMutation(\n  $memberId: ID!\n) {\n  removeWorkspaceMember(memberId: $memberId)\n}\n"
  }
};
})();

(node as any).hash = "ddb3945d8102bd95923a2e9a0d348819";

export default node;
